import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { QueryModelApiConfiguration } from '../apiConfiguration';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { PatientVisitFilter } from 'app/shared/models/core/patient-visit-filter';

@Injectable()
export class EmergencyPatientTrackerService extends ServiceBase {

    private actionUrl: string;
    private _emergencyPatientTracker: string;

    constructor(private _http: HttpClient, private _configuration: QueryModelApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._emergencyPatientTracker = this.actionUrl + _configuration.emergencyPatientTracker.url;
    }

    getEmergencyPatientTracker = (patientVisitFilter: PatientVisitFilter, page: number, rows: number, sortOrder: string = 'DESC'): Observable<any> => {
        const searchText = patientVisitFilter.PatientCode ? patientVisitFilter.PatientCode : '';
        const visitDate = patientVisitFilter.VisitDate ? patientVisitFilter.VisitDate.toDateString() : '';
        const doctorId = patientVisitFilter.DoctorId ? patientVisitFilter.DoctorId : '';

        return this._http.get<any>(this._emergencyPatientTracker
            + '?SearchText=' + encodeURIComponent(searchText)
            + '&VisitDate=' + encodeURIComponent(visitDate)
            + '&DoctorId=' + encodeURIComponent(doctorId)
            + '&Page=' + encodeURIComponent(page)
            + '&Rows=' + encodeURIComponent(rows)
            + '&SortOrder=' + encodeURIComponent(sortOrder)
        );
    }
}
